/**
 * Sticky "Items to Confirm" checklist — soft-gates Create Lead.
 */

import React from "react";
import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";

/**
 * @param {{
 *   items?: Array,
 *   onConfirmField?: (field: string) => void,
 *   onNavigate?: (item: object) => void,
 *   dense?: boolean,
 * }} props
 */
const ConfirmationChecklist = ({
  items = [],
  onConfirmField,
  onNavigate,
  dense = true,
}) => {
  if (!items.length) {
    return (
      <Box data-testid="confirmation-checklist" sx={{ p: 1.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
          Ready to create
        </Typography>
        <Typography variant="body2" color="text.secondary">
          No outstanding confirmation items.
        </Typography>
      </Box>
    );
  }

  return (
    <Box data-testid="confirmation-checklist">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ px: 1.5, pt: 1.5, pb: 0.5 }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          {items.length} item{items.length === 1 ? "" : "s"} need confirmation
        </Typography>
      </Stack>
      <Divider />
      <List dense={dense} disablePadding>
        {items.map((item, index) => (
          <ListItem
            key={item.id}
            divider
            secondaryAction={
              <Button
                size="small"
                variant="text"
                onClick={() => {
                  if (
                    (item.action === "Confirm" || item.action === "Skip") &&
                    item.field &&
                    onConfirmField
                  ) {
                    onConfirmField(item.field);
                    return;
                  }
                  if (onNavigate) onNavigate(item);
                }}
                data-testid={`confirm-action-${item.id}`}
              >
                {item.action || "Review"}
              </Button>
            }
            sx={{ pr: 10 }}
          >
            <ListItemText
              primary={
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {index + 1}. {item.title}
                </Typography>
              }
              secondary={item.detail}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default ConfirmationChecklist;
